import { LOGOUT } from 'data_system/token_auth/actionTypes';

import {
  FETCH_RESOURCE_REQUEST,
  FETCH_RESOURCE_SUCCESS,
  FETCH_RESOURCE_ERROR,
  UPDATE_RESOURCE_REQUEST,
  UPDATE_RESOURCE_SUCCESS,
  UPDATE_RESOURCE_ERROR,
  SHOW_NOTIFICATION,
  UPDATE_RESOURCE_PASSWORD_REQUEST,
  TOGGLE_RESOURCE_MEETING_MODAL,
} from '../actions/resourceActionTypes';

const initialState = {
  resource: {},
  resourceFetching: false,
  resourceError: false,
  resourceUpdating: false,
  resourceUpdatingError: false,
  resourceUpdateNotice: null,
  resourceUpdateNoticeType: 'notice',
  showResourceMeetingModal: false,
};

export const resourceReducer = (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case LOGOUT:
      return { ...initialState };

    case FETCH_RESOURCE_REQUEST:
      return { ...state, resourceFetching: true };

    case FETCH_RESOURCE_SUCCESS:
      return { ...state, resourceFetching: false, resource: action.resource };

    case FETCH_RESOURCE_ERROR:
      return { ...state, resourceFetching: false, resourceError: action.error };

    case UPDATE_RESOURCE_REQUEST:
      return { ...state, resourceUpdating: true };

    case UPDATE_RESOURCE_PASSWORD_REQUEST:
      return { ...state, resourceUpdating: true };

    case UPDATE_RESOURCE_SUCCESS:
      return { ...state, resourceUpdating: false, resource: action.resource };

    case UPDATE_RESOURCE_ERROR:
      return {
        ...state,
        resourceUpdating: false,
        resourceUpdatingError: action.error,
      };

    case TOGGLE_RESOURCE_MEETING_MODAL:
      return { ...state, showResourceMeetingModal: action.visible };

    case SHOW_NOTIFICATION:
      return {
        ...state,
        resourceUpdateNotice: action.notice,
        resourceUpdateNoticeType: action.noticeType,
      };

    default:
      return state;
  }
};
